module.exports = __webpack_public_path__ + "img/plasma-generator.3e11b5f8.png";